const EXTERNAL_LINKS = {
  termsAndConds: "https://hellolluna.com/terms-of-service/",
  privacyPolicy: "https://hellolluna.com/privacy-policy/",
};

export default EXTERNAL_LINKS;
